import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useState } from 'react';

type DeleteDialogProps = {
    onClose?: () => void;
    onDelete?: () => void;
    title: string;
};

const DeleteDialog = ({ onClose, onDelete, title }: DeleteDialogProps) => {
    return (
        <Dialog open={true} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={onDelete} color="error" autoFocus>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export const useDeleteDialog = () => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState('');
    const [onDelete, setOnDelete] = useState<() => void>();

    const handleDelete = () => {
        setShow(false);

        if (onDelete) {
            onDelete();
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = ({ title = '', onDelete }: { title: string; onDelete: () => void }) => {
        setTitle(title);
        setOnDelete(() => () => onDelete());
        setShow(true);
    };

    return {
        DeleteDialog: () => (show ? <DeleteDialog onClose={handleClose} onDelete={handleDelete} title={title} /> : <></>),
        showDialog: handleShow,
    };
};
